// extracted by mini-css-extract-plugin
export var cardContainer = "_nj-0";
export var cardHeader = "_nj-2";
export var collapsedState = "_nj-3";
export var dragHandle = "_nj-5";
export var dragHandleIcon = "_nj-6";
export var dragging = "_nj-1";
export var titleArea = "_nj-4";